import { Bell } from 'lucide-react';
import { TickRing } from './TickRing';
import { RoundButton } from './RoundButton';
import { fmtCountdown, fmtDurationLabel, fmtClockTime } from './clockUtils';

export const CountdownRunning = ({ total, remaining, running, done, onCancel, onPause, onResume }) => (
  <div className="flex flex-col items-center w-full" data-testid="countdown-running">
    <TickRing progress={total ? remaining / total : 0} paused={!running && !done}>
      <span className="text-sm text-white/50" data-testid="countdown-total-label">{fmtDurationLabel(total)}</span>
      <span
        className={`tabular-nums font-bold leading-none my-2 text-[40px] sm:text-[52px] ${done ? 'text-primary animate-pulse' : 'text-white'}`}
        data-testid="countdown-display"
      >
        {done ? "Time's up" : fmtCountdown(remaining)}
      </span>
      {!done && (
        <span className={`flex items-center gap-1 text-sm ${running ? 'text-white/60' : 'text-white/30'}`} data-testid="countdown-end-time">
          <Bell className="h-3.5 w-3.5" />
          {running ? fmtClockTime(new Date(Date.now() + remaining)) : 'Paused'}
        </span>
      )}
    </TickRing>

    <div className="mt-10 flex w-full max-w-[300px] justify-between">
      <RoundButton onClick={onCancel} data-testid="countdown-cancel-btn">{done ? 'Done' : 'Cancel'}</RoundButton>
      {done ? (
        <RoundButton variant="primary" onClick={onResume} data-testid="countdown-restart-btn">Restart</RoundButton>
      ) : running ? (
        <RoundButton variant="danger" onClick={onPause} data-testid="countdown-pause-btn">Pause</RoundButton>
      ) : (
        <RoundButton variant="primary" onClick={onResume} data-testid="countdown-resume-btn">Resume</RoundButton>
      )}
    </div>
  </div>
);

export default CountdownRunning;
